export default __webpack_public_path__ + "static/media/green_mustache.1d358aae.svg";